import { render, staticRenderFns } from "./MedicineForm.vue?vue&type=template&id=53433b10&scoped=true"
import script from "./MedicineForm.vue?vue&type=script&lang=js"
export * from "./MedicineForm.vue?vue&type=script&lang=js"
import style0 from "./MedicineForm.vue?vue&type=style&index=0&id=53433b10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53433b10",
  null
  
)

export default component.exports